export const getAlgoliaIndexName = (countryId?: string) => {
  switch (countryId) {
    case 'DE':
      return 'shine.co-de'
    case 'NL':
      return 'shine.co-nl'
    default:
      return 'website'
  }
}
